import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Nodes/EntityRender.tsx";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable react/forbid-component-props */
import * as React from 'react';
import { useDrag } from 'react-dnd';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import { useNodeCtxMenu } from "../explorer.context";
import { closeItemForm, useCurrentRenaming, useHover } from "../Model";
import { useBaseRenderProps } from "../BaseRenderProps";
import { NodeNameForm } from "../NodeNameForm";
import { usePending } from "../PendingContext";
import { DndExplorerType } from "../dnd";
import { ExplorerLayout } from "./NodeLayout";
import { jsx as _jsx } from "react/jsx-runtime";
export var EntityRender = /*#__PURE__*/React.memo(function (props) {
  var node = props.item.payload;

  var _useDrag = useDrag({
    item: {
      node: node,
      type: DndExplorerType
    },
    canDrag: !node.readOnly,
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 2),
      isDragging = _useDrag2[0].isDragging,
      ref = _useDrag2[1];

  var _ref = useBaseRenderProps() || {},
      entityIcon = _ref.entityIcon,
      _ref$assemblyIcon = _ref.assemblyIcon,
      assemblyIcon = _ref$assemblyIcon === void 0 ? null : _ref$assemblyIcon,
      onRename = _ref.onRename,
      onEntityOpen = _ref.onEntityOpen;

  var classes = useStyles();

  var _usePending = usePending(),
      pending = _usePending.pending,
      ifPromise = _usePending.ifPromise;

  var _useHover = useHover(),
      hover = _useHover.hover,
      onMouseLeave = _useHover.onMouseLeave,
      onMouseOver = _useHover.onMouseOver;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      textIsLong = _React$useState2[0],
      setTextIsLong = _React$useState2[1];

  var _useNodeCtxMenu = useNodeCtxMenu(node),
      onContextMenu = _useNodeCtxMenu.onContextMenu,
      opened = _useNodeCtxMenu.open;

  var parentCategoryId = node.parentNode && node.parentNode.type === 'Category' ? node.parentNode.id : null;
  var handleRename = React.useCallback(function (_, newName) {
    if (onRename) {
      var _ifPromise;

      (_ifPromise = ifPromise(onRename({
        id: node.id,
        type: node.type,
        newName: newName,
        version: node.version,
        parentCategoryId: parentCategoryId
      }))) === null || _ifPromise === void 0 ? void 0 : _ifPromise.then(closeItemForm);
    }
  }, [ifPromise, node.id, node.type, node.version, onRename, parentCategoryId]);
  var renaming = useCurrentRenaming(node);
  var onClick = React.useCallback(function (e) {
    return e.preventDefault();
  }, []);
  var handleOpen = React.useCallback(function () {
    return onEntityOpen === null || onEntityOpen === void 0 ? void 0 : onEntityOpen(node.id, node.type);
  }, [node.id, node.type, onEntityOpen]);

  if (!entityIcon) {
    return null;
  }

  if (renaming) {
    return /*#__PURE__*/_jsx(NodeNameForm, {
      icon: node.type === 'Assembly' && assemblyIcon ? assemblyIcon : entityIcon,
      pending: pending,
      onClose: closeItemForm,
      onSubmit: handleRename,
      defaultName: node.title
    });
  }

  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    children: /*#__PURE__*/_jsx(ExplorerLayout, {
      onMouseOver: onMouseOver,
      onMouseLeave: onMouseLeave,
      onClick: onClick,
      className: clsx(classes.root, _defineProperty({}, classes.dragging, isDragging)),
      handleOpen: handleOpen,
      empty: true,
      onContextMenu: onContextMenu,
      icon: node.type === 'Entity' ? entityIcon : assemblyIcon,
      textIsLong: textIsLong,
      node: node,
      hover: hover,
      pending: pending,
      setTextIsLong: setTextIsLong,
      opened: opened,
      tooltipTitle: node.owner ? "\u0410\u0432\u0442\u043E\u0440: ".concat(node.owner, " ") : '',
      noMaxWidth: !!(node.type === 'Entity' && "\u0410\u0432\u0442\u043E\u0440: ".concat(node.owner))
    })
  });
});
EntityRender.displayName = 'EntityRender';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      borderRadius: '4px 0  0 4px',
      paddingLeft: '6px',
      paddingTop: '2px',
      paddingBottom: '2px'
    },
    dragging: {
      opacity: 0.5,
      backgroundColor: '#fff'
    }
  };
});